import moment, { Moment } from "moment";

export const useWorkingDaysInPeriod = () => {
    return (workingDays: any[], dateBegin: string | Moment, dateEnd: string | Moment) => {
        if (!workingDays || !dateBegin || !dateEnd) return [];

        const start = moment(dateBegin);
        const end = moment(dateEnd);
        const result: any[] = [];

        workingDays.forEach((wd: any) => {
            const wdStart = moment(wd.startDate);
            const wdEnd = moment(wd.endDate);

            const isInPeriod = wdStart.isBetween(start, end, 'day', '[]') ||
                      wdEnd.isBetween(start, end, 'day', '[]') ||
                      (wdStart.isBefore(start) && wdEnd.isAfter(end));

            if (wd.isWeeklyRepetitive) {
                const wdDayOfWeek = wdStart.day();
                const current = start.clone();
                
                while (current.isSameOrBefore(end, 'day')) {
                    if (current.day() === wdDayOfWeek && !result.some(r => moment(r.startDate).format('YYYY-MM-DD') === current.format('YYYY-MM-DD'))) {
                        result.push({
                            ...wd,
                            id: `${wd.id}-${current.format('YYYY-MM-DD')}`,
                            startDate: current.format('YYYY-MM-DD'),
                            endDate: current.format('YYYY-MM-DD'),
                            isWeeklyRepetitive: false,
                            originalWorkingDayId: wd.id,
                            label: `${wd.name || 'Working Day'} - ${current.format('DD/MM/YYYY')}`
                        });
                    }
                    current.add(1, 'day');
                }
            } else if (isInPeriod) {
                result.push(wd);
            }
        });

        return result;
    };
};